import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../AdminSidebar';
import AdminHeader from '../AdminHeader';
import { useSidebar } from '../../../contexts/SidebarContext';
// import { useSidebar } from '../../contexts/SidebarContext';
// useSidebar
const AdminLayout = () => {
  const { isAdminSidebarCollapsed, isAdminMobileSidebarOpen } = useSidebar();
  
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <div className="flex pt-20"> {/* Add top padding to account for fixed header */}
        <AdminSidebar />
        <main className={`flex-1 transition-all duration-300 ${
          isAdminSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'
        } ${isAdminMobileSidebarOpen ? 'lg:ml-0' : ''}`}>
          <div className="p-4 sm:p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
